import { render, staticRenderFns } from "./MobileAppRegistration.vue?vue&type=template&id=73cfac55"
import script from "./MobileAppRegistration.vue?vue&type=script&lang=ts"
export * from "./MobileAppRegistration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports